
// Update Cart Quantity on Sign Out
function updateCartOnSignOut() {
    fetch(globalObject.url + "ajax/ecommerce.php?action=getCartQuantity", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.text())
        .then((data) => {
            console.log('fetched: ', data);
            const cartQuantity = document.querySelector(".cartQuantity");
            cartQuantity.innerHTML = data;
            if (data > 0) {
                cartQuantity.classList.remove("noCartQuantity");
            } else {
                cartQuantity.classList.add("noCartQuantity");
            }
        })
        .catch((error) => console.error("Error:", error));
}

document.addEventListener("DOMContentLoaded", () => {
    if (window.location.href.includes("sign-in?action=logout")) {
		updateCartOnSignOut();
    }
});

/* Sign Up Page */
// TODO: Remove JQuery
$(document).ready(function () {
    var buttonActivated = false;
    $(".createAccountButton").click(function (e) {
        if (!buttonActivated) {
            e.preventDefault();
        }
        if (document.documentElement.clientWidth > 1280) {
            $(".loginBox").animate(
                { marginLeft: "-97%", width: "97%" },
                function () {
                    $(this).hide();
                }
            );
        } else {
            $(".loginBox").slideUp();
        }
        $(".signupBox").animate({ width: "97%" });
        $(".signupBox").css({ "border-left": "0" });
        $(".signupBox").css({ "border-top": "0" });
        //$('.signupInfo').slideUp();
        $(".signupFormElement").slideDown();
        $(".loginMessage").slideUp();
        if (document.documentElement.clientWidth < 1280) {
            $("html, body").animate(
                {
                    scrollTop: $(".loginContainer").offset().top - 10,
                },
                500
            );
        }
        buttonActivated = true;
    });
    $(".resetPasswordLink").click(function () {
        showPasswordReset();
    });
    $(".newWishlistBox").click(function () {
        $(".wishlistUnderlay").fadeIn();
    });
    $(".emailWishlistButton").click(function () {
        $(".emailWishlist").show();
        $(".deleteWishlist").hide();
        $(".editWishlist").hide();
        $(".wishlistMessage").hide();
        $(".wishlistUnderlay").fadeIn();
    });
    $(".editWishlistButton").click(function () {
        $(".editWishlist").show();
        $(".deleteWishlist").hide();
        $(".emailWishlist").hide();
        $(".wishlistMessage").hide();
        $(".wishlistUnderlay").fadeIn();
    });
    $(".deleteWishlistButton").click(function () {
        $(".deleteWishlist").show();
        $(".emailWishlist").hide();
        $(".editWishlist").hide();
        $(".wishlistMessage").hide();
        $(".wishlistUnderlay").fadeIn();
    });
    $(".deleteWishlistForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=delete-wishlist",
            dataType: "text",
            success: function (response) {
                if (response != 0) {
                    window.location.href = response;
                } else {
                    if ($(".wishlistError").length) {
                        $(".wishlistError").show();
                    }
                }
            },
        });
    });
    $(".emailWishlistForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=email-wishlist",
            dataType: "text",
            success: function (response) {
                if (response == 1) {
                    $(".wishlistUnderlay").fadeOut();
                } else {
                    if ($(".wishlistError").length) {
                        $(".wishlistError").show();
                    }
                }
            },
        });
    });
    $(".editWishlistForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=edit-wishlist",
            dataType: "text",
            success: function (response) {
                if (response == 1) {
                    window.location.reload();
                } else {
                    if ($(".wishlistError").length) {
                        $(".wishlistError").show();
                    }
                }
            },
        });
    });
    $("#wishlistPrivate").change(function () {
        $(".privateDescription").slideDown();
        $(".publicDescription").slideUp();
    });
    $("#wishlistPublic").change(function () {
        $(".publicDescription").slideDown();
        $(".privateDescription").slideUp();
    });
    $(".newWishlistForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=new-wishlist",
            dataType: "text",
            success: function (response) {
                if (response != 0) {
                    window.location.href = response;
                } else {
                    if ($(".wishlistError").length) {
                        $(".wishlistError").show();
                    }
                }
            },
        });
    });

    $(".newAddress").click(function () {
        $(".deleteAddressForm").hide();
        $(".newAddressForm").show();
        $(".wishlistUnderlay").fadeIn();
        var addressType = $(this).data("type");
        var countryCode = $(".newAddressForm .countryCode").val();
        if (countryCode == "KY") {
            if (addressType == "Shipping") {
                $(".newAddressForm .zip").hide();
            } else if (addressType == "Billing") {
                $(".newAddressForm .zip").show();
            }
        }
        $(".newAddressForm .addressType").val(addressType);
        $(".newAddressForm .titleType").html(addressType);
    });
    $(".deleteAddress").click(function () {
        $(".newAddressForm").hide();
        $(".deleteAddressForm").show();
        $(".wishlistUnderlay").fadeIn();
        var addressType = $(this).data("type");
        $(".deleteAddressForm .addressType").val(addressType);
        var firstName = $(this).data("first");
        var lastName = $(this).data("last");
        var phone = $(this).data("phone");
        var address = $(this).data("address");
        var address2 = $(this).data("address2");
        var city = $(this).data("city");
        var state = $(this).data("state");
        var zip = $(this).data("zip");
        $(".confirmFirstName").html(firstName);
        $(".confirmLastName").html(lastName);
        $(".confirmPhone").html(phone);
        $(".confirmAddress").html(address);
        if (address2 != "") {
            $(".confirmAddress2").html(address2 + "<br>");
        } else {
            $(".confirmAddress2").html("");
        }
        $(".confirmCity").html(city);
        $(".confirmState").html(state);
        $(".confirmZip").html(zip);
        $(".deleteAddressForm #firstName").val(firstName);
        $(".deleteAddressForm #lastName").val(lastName);
        $(".deleteAddressForm #phone").val(phone);
        $(".deleteAddressForm #address").val(address);
        $(".deleteAddressForm #address2").val(address2);
        $(".deleteAddressForm #city").val(city);
        $(".deleteAddressForm #state").val(state);
        $(".deleteAddressForm #zip").val(zip);
    });

    $(".newAddressForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=add-address",
            dataType: "text",
            success: function (response) {
                if (response == "1") {
                    window.location.href = window.location.href;
                } else {
                    if ($(".newAddressForm .error").length) {
                        $(".newAddressForm .error").show();
                    }
                    console.log(response);
                }
            },
        });
    });
    $(".deleteAddressForm").submit(function (e) {
        e.preventDefault();
        var data = $(this).serialize();
        $.ajax({
            data: data,
            type: "POST",
            url: globalObject.url + "ajax/account.php?action=delete-address",
            dataType: "text",
            success: function (response) {
                if (response == "1") {
                    window.location.href = window.location.href;
                } else {
                    if ($(".deleteAddressForm .error").length) {
                        $(".deleteAddressForm .error").show();
                    }
                    console.log(response);
                }
            },
        });
    });
});

// TODO: Remove JQuery
function showPasswordReset() {
    $(".loginDefaultView").slideUp();
    $(".resetPasswordContainer").slideDown();
}

// TODO: Remove JQuery
function emailListSubscription(email, option, pageTime) {
    if (option == "unsubscribe") {
        var confirm = window.confirm(
            "Are you sure you want to unsubscribe from our mailing list?"
        );
        if (confirm == false) {
            return false;
        } else {
            $.ajax({
                data: { email: email, option: option, pageTime: pageTime },
                type: "POST",
                url:
                    globalObject.url +
                    "ajax/account.php?action=email-list-subscription",
                dataType: "text",
                success: function (response) {
                    if (response == "1") {
                        console.log(response);
                        window.location.reload();
                    } else {
                        const status = document.getElementById(
                            "emailListSubscriptionStatus"
                        );
                        status.classList.add("redError");
                        status.innerHTML =
                            "Error processing. Contact administrator for assistance.";
                        console.log(response);
                    }
                },
            });
        }
    } else {
        $.ajax({
            data: { email: email, option: option, pageTime: pageTime },
            type: "POST",
            url:
                globalObject.url +
                "ajax/account.php?action=email-list-subscription",
            dataType: "text",
            success: function (response) {
                if (response == "1") {
                    console.log(response);
                    window.location.reload();
                } else {
                    const status = document.getElementById(
                        "emailListSubscriptionStatus"
                    );
                    status.classList.add("redError");
                    status.innerHTML =
                        "Error processing. Contact administrator for assistance.";
                    console.log(response);
                }
            },
        });
    }
}
